export function basicTask() {
	const backTop = document.querySelector(".back-to-top");
	const counterItem = document.querySelectorAll(".counter");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const bodyWrap = document.querySelector("body");
	const menuMobile = document.querySelector(".mobile-nav-wrap");
	const searchWrap = document.querySelector(".search-overlay");
	const hamburger = document.querySelector(".hamburger");

	const filterToggle = document.querySelector(".filter-toggle");
	const closeFilter = document.querySelector(".close-filter");
	const mobileFilter = document.querySelector(".mobile-filter");




	const breadcrumb = document.querySelector(".global-breadcrumb");
	const breadcrumb_wrap = document.querySelector(".global-breadcrumb .container");

	const cardHover = $('.card-option');

	cardHover.on('mouseenter', function () {
		$('.card-option').removeClass('active');
		$(this).toggleClass('active');
	});
	//Basic Toggle Function
	menuToggle.addEventListener("click", (e) => {
		e.preventDefault();
		menuMobile.classList.toggle("is-open");
		hamburger.classList.toggle("is-active");
		bodyWrap.classList.toggle("overlay-bg");
	});
	closeMenu.addEventListener("click", () => {
		menuMobile.classList.remove("is-open");
		hamburger.classList.remove("is-active");
		bodyWrap.classList.remove("overlay-bg");
	});

	// Search Toggle
	searchToggle.addEventListener("click", () => {
		searchWrap.classList.toggle("is-open");
		bodyWrap.classList.toggle("overlay-bg");
	});
	try {
		const sideNav = document.querySelector(".side-nav .title");
		const sideNavWrap = sideNav.nextElementSibling;
		sideNav.addEventListener("click", () => {
			sideNavWrap.classList.toggle('is-open');
		});



	} catch (error) {

	}
	if ($(window).width() < 1200.1) {
		//Drop down menu
		$(".drop-down .title .icon").on("click", function () {
			$(this).parent().toggleClass('is-open');
			$(this).parent().next().slideToggle();
		});
	}



	$(".tab-nav-hover a").on("mouseenter", function () {
		$(this).parents(".tab-nav").find("li").removeClass("active");
		$('.tab-nav-hover li').removeClass('active');
		$(this).parents("li").addClass("active");

		var tab = $(this).attr("data-type");

		$(this).parents("section").find(".tab-item").removeClass("active");
		$(this)
			.parents("section")
			.find("#" + tab)
			.addClass("active");
	});
	//back to top
	try {
		if (backTop !== null) {
			backTop.addEventListener("click", (event) => {
				event.preventDefault();
				$("html, body").animate({ scrollTop: 0 }, "300");
			});
		}


		$(".filter-table-wrap").each(function () {
			let x = 10;
			$(this).find("tbody tr").slice(0, 10).show();
			let size = $(this).find("tbody tr").length;
			if (size < x || size == x) {
				$(this).find(".ajax-btn-wrap").addClass("disble-btn");
			}
			$(".filter-table-wrap")
				.find(".btn-view-more")
				.on("click", function (e) {
					e.preventDefault();
					x = x + 6;
					$(this)
						.parents(".filter-table-wrap")
						.find("tbody tr")
						.slice(0, x)
						.slideDown();
					if (x >= size || size < x) {
						$(this).parent().addClass("disble-btn");
					}
				});
		});
	} catch (error) {

	}

	//Tab function
	if (filterToggle !== null) {
		filterToggle.addEventListener("click", () => {
			mobileFilter.classList.add("is-open");
			hamburger.classList.remove("is-active");
			bodyWrap.classList.add("overlay-bg");
		});
		closeFilter.addEventListener("click", () => {
			mobileFilter.classList.remove("is-open");
			hamburger.classList.remove("is-active");
			bodyWrap.classList.remove("overlay-bg");
		});
	}


	if ($('body').hasClass('news-detail-page')) {
		if ($('.banner-breadcrumb-2').length) {
			$('.global-breadcrumb').appendTo('.banner-breadcrumb-2 .banner-breadcrumb-wrap')
		}
	}



	if ($('.banner-breadcrumb').length) {
		// Ensure breadcrumb is defined
		if (breadcrumb !== null) {
			let anchorElements = breadcrumb.querySelectorAll(":scope li");
			let secondAnchor = anchorElements[1];
			let thirddAnchor = anchorElements[2];
			// Prevent duplicates
			if (!breadcrumb.querySelector("h2")) {
				let title;
				if (anchorElements.length > 1 && anchorElements.length < 4) {
					title = secondAnchor.innerText || "Default Title";
				} else if (anchorElements.length > 3) {
					title = thirddAnchor.innerText || "Default Title";
				} else {
					return;
				}
				let newNode = document.createElement("h2");
				newNode.textContent = title;
				breadcrumb_wrap.appendChild(newNode);
			}
		} else {
		}
	}



	if ($(window).width() < 1200.1) {

		//Drop down menu
		let clickCount = 0;
		let lastClickedElement = null;

		$(".menu-item-has-children > a").on("click", function (e) {
			e.preventDefault();

			if (lastClickedElement && lastClickedElement !== this) {
				clickCount = 0;
			}

			clickCount++;
			lastClickedElement = this;

			if (clickCount === 1) {
				if (
					$(this)
						.parents(".menu-item-has-children")
						.hasClass("is-open")
				) {
					$(".menu-item-has-children .sub-menu").slideUp();
					$(".menu-item-has-children").removeClass("is-open");
				} else {
					$(".menu-item-has-children .sub-menu").slideUp();
					$(".menu-item-has-children").removeClass("is-open");
					$(this).next().slideDown();
					$(this)
						.parents(".menu-item-has-children")
						.addClass("is-open");
				}
			} else if (clickCount === 2) {
				window.location.href = $(this).attr("href");
			}
		});
	}


	// $(".toggle-wrap").each(function (index, element) {
	// 	let $this = $(this);
	// 	$this.addClass("toggle-instance-" + index);
	// 	$(".toggle-instance-" + index + " .toggle-item").click(function () {
	// 		if ($(this).hasClass("is-toggle")) {
	// 			$(this).find(".article").slideUp();
	// 			$(this).removeClass("is-toggle");
	// 		} else {
	// 			$(this).find(".article").slideDown();
	// 			$(this).addClass("is-toggle");
	// 		}
	// 	});
	// });





	//Toggle item
	document.querySelectorAll(".toggle-wrap").forEach((wrap, index) => {
		wrap.classList.add("toggle-instance-" + index);

		wrap.querySelectorAll(
			".toggle-instance-" + index + " .toggle-item"
		).forEach((item) => {
			item.addEventListener("click", () => {
				if (item.classList.contains("is-toggle")) {
					item.querySelector(".article").style.display = "none";
					item.classList.remove("is-toggle");
				} else {
					document
						.querySelectorAll(
							".toggle-instance-" + index + " .toggle-item"
						)
						.forEach((otherItem) => {
							otherItem.classList.remove("is-toggle");
							otherItem.querySelector(".article").style.display =
								"none";
						});
					item.querySelector(".article").style.display = "block";
					item.classList.add("is-toggle");
				}
			});
		});
	});

	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	if (counterItem !== null) {
		if (counterItem.length) {
			const counterUp = window.counterUp.default;
			const callback = (entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					if (
						entry.isIntersecting &&
						!el.classList.contains("is-visible")
					) {
						counterUp(el, {
							duration: 2000,
							delay: 200,
						});
						el.classList.add("is-visible");
					}
				});
			};
			const IO = new IntersectionObserver(callback, { threshold: 1 });

			counterItem.forEach((counter) => {
				IO.observe(counter);
			});
		}
	}
}
